import { defineAsyncComponent } from "vue";

const TheHeader = defineAsyncComponent(() => import("./ui/the-header.vue"));

export { TheHeader };
